// extracted by mini-css-extract-plugin
module.exports = {"exclusiveSection":"ExclusiveSection_exclusiveSection__ue87Q"};